
export function formatNumber(num: any, fractionDigits?: number, dynamic?: boolean) {
    if (num === '' || num === null || num === undefined || isNaN(num)) {
        return '';
    }
    return new Intl.NumberFormat(
        'de-DE',
        {
            maximumFractionDigits: fractionDigits >= 0 ? fractionDigits : 3,
            minimumFractionDigits: fractionDigits >= 0 && !dynamic ? fractionDigits : 0
        }
    ).format(num);
}

export function fn1(num: any) {
    return formatNumber(num, 1);
}

export function fn1nZ(num: any) {   // nZ  = no zero
    if (+num === 0) {
        return ' ';
    }
    return formatNumber(num, 1);
}

export function fn0(num: any) {
    return formatNumber(num, 0);
}

export function fn2(num: any) {
    return formatNumber(num, 2);
}

export function fn2d(num: any) {
    return formatNumber(num, 2, true);
}

export function fn0nZ(num: any) {   // nZ  = no zero
    if (+num === 0) {
        return ' ';
    }
    return formatNumber(num, 0);
}

export function fn2nZ(num: any) {   // nZ  = no zero
    if (+num === 0) {
        return ' ';
    }
    return formatNumber(num, 2);
}

export function fn4nZ(num: any) {   // nZ  = no zero
    if (+num === 0) {
        return ' ';
    }
    return formatNumber(num, 4);
}

export function fn3d(num: any) {
    return formatNumber(num, 3, true);
}

export function fnAuto(num: any, maxDeciLength?: number) {
    // console.log(typeof num, num);
    if (typeof num !== 'number') {
        return num;
    }
    let deciLength = countDecimals(num);
    if (maxDeciLength > 0) {
        deciLength = Math.min(maxDeciLength, deciLength);
    }
    return formatNumber(num, deciLength, true);
}

export function toFixedDecimal(num: number, fractionDigits = 3) {
    const str = num.toString();
    const comPos = str.indexOf('.');
    if (comPos !== -1) {
        const comLen = str.length - comPos - 1;
        if (comLen > fractionDigits) {
            const formatted = +(+num).toFixed(fractionDigits);
            return formatted;
        }
    }
    return num;
}

export function countDecimals(num: number) {
    if (typeof num === 'number') {
        const numStr = num.toString();
        if (numStr.indexOf('e-') !== -1) {
            // 0.0000005 = 5e-7
            const arr = numStr.split("e-");
            return parseInt(arr[1]);
        } else if (numStr.indexOf('.') !== -1) {
            const arr = numStr.split(".");
            if (arr[1]) {
                return arr[1].length;
            }
        }
    }
    return 0;
}
